// extracted by mini-css-extract-plugin
export default {"logo":"ValidationPage_logo__8TvMx","content":"ValidationPage_content__cOe2H","text":"ValidationPage_text__abNLM"};